// extracted by mini-css-extract-plugin
export default {"modal":"View_modal__rHXyF","wrapper":"View_wrapper__A3rfK"};